import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const slideIn = keyframes`
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const PopupContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${slideIn} 0.5s ease-out;
  width: 50%;
  max-height: 80vh;
  overflow-y: auto;
`;

const PopupContent = styled.div`
  background: ${({ theme }) => theme.colors.light};
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 30px;
  position: relative;
  border-left: 4px solid ${({ theme }) => theme.colors.primary};
  width: 100%;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray};
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.dark};
  }
`;

const Title = styled.h3`
  margin: 0 0 10px;
  color: ${({ theme }) => theme.colors.primary};
  padding-right: 20px;
`;

const Message = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSizes.medium};
`;

const NewsPopup = ({ title, message, duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose?.();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  if (!isVisible) return null;

  return (
    <PopupOverlay onClick={(e) => {
      if (e.target === e.currentTarget) {
        setIsVisible(false);
        onClose?.();
      }
    }}>
      <PopupContainer>
        <PopupContent>
        <CloseButton aria-label="Close announcement" onClick={() => {
          setIsVisible(false);
          onClose?.();
        }}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </PopupContent>
      </PopupContainer>
    </PopupOverlay>
  );
};

export default NewsPopup;
